<template>
  <div class="home-container my-5 mx-5 my-sm-15 mx-sm-10 rounded-xl pa-5">
    <v-row>
      <v-col cols="12">
        <statistics-list />
      </v-col>


      <v-col v-if="havePermissionGetTrainingRegistrations" cols="12">
        <recent-registrations />
      </v-col>

      <v-col v-if="havePermissionGetApprovalPendingTrainings" cols="12">
        <recently-added-courses />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StatisticsList from "../../statistics-module/components/StatisticsList.vue";
import RecentRegistrations from "../../user-module/components/RecentRegistrations.vue";
import RecentlyAddedCourses from "../../course-module/components/ApprovalPendingCourses.vue";

import { hasPermission, isAdmin } from "@/app/user-module/helpers/authHelper";

export default {
  name: "HomePage",
  components: {
    StatisticsList,
    RecentRegistrations,
    RecentlyAddedCourses,
  },
  computed: {
    havePermissionCreateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionGetTrainingRegistrations() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_TRAINING_REGISTRATIONS"],
      });
    },
    havePermissionGetApprovalPendingTrainings() {
      return this.$store.state.authenticatedUserRole === "ADMIN";
    },
  },
};
</script>

<style scoped>
.home-container {
  background: linear-gradient(180deg, #fbfbfd 0%, #f4f5f8 100%);
  min-height: calc(100vh - 100px);
}
</style>
